// client/src/utils/chicagoMiles.js — straight-line miles from downtown Chicago (the Loop, State & Madison)
// for towns outside Illinois, shown beside the town in residential search results and emails
// (owner, 26 Oct 2026: "add the miles from the Loop to the info for reference"; the Indiana
// towns in his home search are limited to 30 miles). The server copy is lib/chicagoMiles.js;
// scripts/test-residential-search.js keeps them identical.
// Add a town here (with its coordinates) to give it a distance; unknown towns show none.
const LOOP = [41.8819, -87.6278];
const TOWNS = {
    'whiting|IN': [41.6797, -87.4945], 'east chicago|IN': [41.6392, -87.4548], 'hammond|IN': [41.5834, -87.5000],
    'munster|IN': [41.5645, -87.5125], 'highland|IN': [41.5537, -87.4520], 'gary|IN': [41.5934, -87.3464],
    'griffith|IN': [41.5284, -87.4237], 'dyer|IN': [41.4942, -87.5217], 'lake station|IN': [41.5750, -87.2389],
    'schererville|IN': [41.4789, -87.4548], 'hobart|IN': [41.5323, -87.2550], 'st. john|IN': [41.4500, -87.4700],
    'merrillville|IN': [41.4828, -87.3328], 'crown point|IN': [41.4170, -87.3653], 'cedar lake|IN': [41.3648, -87.4411],
    'lowell|IN': [41.2914, -87.4206], 'portage|IN': [41.5759, -87.1762], 'valparaiso|IN': [41.4731, -87.0611],
    'chesterton|IN': [41.6106, -87.0642]
};
const rad = (d) => (d * Math.PI) / 180;
function milesBetween([la1, lo1], [la2, lo2]) {
    const h = Math.sin(rad(la2 - la1) / 2) ** 2 + Math.cos(rad(la1)) * Math.cos(rad(la2)) * Math.sin(rad(lo2 - lo1) / 2) ** 2;
    return 3958.8 * 2 * Math.asin(Math.sqrt(h));
}
/** Miles from the Loop, one decimal, for a known town outside Illinois; otherwise null. */
function milesFromLoop(city, state) {
    const st = String(state || '').toUpperCase();
    if (!city || st === 'IL') return null;
    const c = TOWNS[`${String(city).trim().toLowerCase().replace(/^saint /, 'st. ')}|${st}`];
    return c ? Math.round(milesBetween(LOOP, c) * 10) / 10 : null;
}
/** " · 24.7 mi from the Loop" or "". */
const milesNote = (city, state) => { const m = milesFromLoop(city, state); return m == null ? '' : ` · ${m} mi from the Loop`; };

export { LOOP, TOWNS, milesBetween, milesFromLoop, milesNote };
